module.exports = __webpack_public_path__ + "img/plus-blue.3800f597.svg";